import React, { useCallback, useEffect, useState, useRef } from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { medicinecategory } from '../service';
import FormControl from '@mui/material/FormControl';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import RestartAltIcon from '@mui/icons-material/RestartAlt';
import MenuItem from '@mui/material/MenuItem';
import useMedicineLayoutStore from '../medicine.zustandstore';
import '../medicine.css';

function Search() {
	const [medicineCategoryList, setMedicineCategoryList] = useState([]);
    const [formData, setFormData] = useState({});
    const [errors, setErrors] = useState({});
    const formSubmitted = useRef(false);
    const { setSearchTerm, setSelectedCategory, fetchMedicines } = useMedicineLayoutStore();

	const getMedicineCategoryList = useCallback(async () => {
		try {
			const res = await medicinecategory();
			const transformed = res.data.map((item, index) => ({
				...item,
				index: index + 1,
			}));
			setMedicineCategoryList(transformed);
		} catch (error) {
			console.error(error);
			setMedicineCategoryList([]);
		}
	}, []);

	useEffect(() => {
		getMedicineCategoryList();
	}, [getMedicineCategoryList]);

    const handleSearch = async () => {
        formSubmitted.current = true;
        const searchTerm = formData.searchQuery || undefined;
        const categoryId = formData.prescriptionMedicine || undefined;
        setSearchTerm(searchTerm);
        setSelectedCategory(categoryId);
        fetchMedicines(1);
    };

    const handleReset = () => {
        setFormData({});
		setErrors({});
        setSearchTerm();
        setSelectedCategory();
        fetchMedicines(1);
		formSubmitted.current = false;
    };

    const setFormValue = (field, value) => {
        const tmp = { ...formData, [field]: value };
        setFormData(tmp);
    };

	return (
        <>
        <Grid
            container
            spacing={2}
            sx={{
                display: 'flex',
                justifyContent: 'center',
            }}
        >
        <Grid item xs={12} sm={3}>
            <FormControl fullWidth>
                <TextField
                    label='--   Prescription Medicine   --'
                    value={formData.prescriptionMedicine || ''}
                    fullWidth
                    size='small'
                    select
                    onChange={e => setFormValue('prescriptionMedicine', e.target.value)}
                    // {...(errors.prescriptionMedicine ? { error: true, helperText: 'This field is required.' } : {})}
                >
                    {medicineCategoryList.map(sm => <MenuItem key={`sm-menu-${sm.id}`} value={sm.id} name={sm.name}>{sm.name}</MenuItem>)}
                </TextField>
            </FormControl>
        </Grid><Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                    <TextField
                        label='Search Query'
                        variant='outlined'
                        size='small'
                        fullWidth
                        value={formData.searchQuery || ''}
                        onChange={e => setFormValue('searchQuery', e.target.value)}
                        {...(errors.searchQuery ? { error: true, helperText: 'This field is required.' } : {})} />
                </FormControl>
            </Grid><Grid item xs={12} sm={3}>
                <FormControl fullWidth>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                        <Button variant='contained' fullWidth className='btn-square' onClick={handleSearch}>
                            Search
                        </Button>
                        <IconButton
                            color="primary"
                            disabled={!formData.prescriptionMedicine && !formData.searchQuery}
                            onClick={handleReset}
                        >
                            <RestartAltIcon />
                        </IconButton>
                    </Box>
                </FormControl>
            </Grid>
            </Grid></>
	);
}

export default Search;
